// IP Redirect
let selected_country_param = getUrlParameter('selected_country');

if (selected_country_param) {
  Cookies.set('selected_country', selected_country_param, { expires: 1 })
  $('#country_redirect_popup').addClass('hide');
} else {
  $.ajax( {
    url: 'https://freegeoip.app/json/',
    type: 'GET',
    success: function(data) {
      // If the visitor is browsing from Canada.
      let selected_country = Cookies.get('selected_country');
      if (!selected_country) {
        if (data.country_code == 'US') {
          Cookies.set('selected_country', 'US', { expires: 5 })
          //window.location.href = "https://ghostkeyboards.com/";
        }
        else if(data.country_code == 'EU'){
          Cookies.set('selected_country', 'EU', { expires: 5 })
          window.location.href = "https://eu.ghostkeyboards.com/";
        }
        else if(data.country_code == 'CA'){
          Cookies.set('selected_country', 'CA', { expires: 5 })
          window.location.href = "https://ca.ghostkeyboards.com/";
        }
        else if(data.country_code == 'UK'){
          Cookies.set('selected_country', 'UK', { expires: 5 })
          window.location.href = "https://uk.ghostkeyboards.com/";
        }
        else{
          $('#country_name').text(data.country_name);
          $('#country_redirect_popup').removeClass('hide');
        }
      } else {
        $('#country_redirect_popup').addClass('hide');
      }
    }
  });
}

$('#close_popup').click(function () {
  Cookies.set('selected_country', 'US', { expires: 5 })
  $('#country_redirect_popup').addClass('hide');
})

$('#country_eu').click(function () {
  Cookies.set('selected_country', 'EU', { expires: 5 })
})

$('#country_ca').click(function () {
  Cookies.set('selected_country', 'CA', { expires: 5 })
})

$('#country_uk').click(function () {
  Cookies.set('selected_country', 'UK', { expires: 5 })
})


// Add on slick
$(document).ready(function(){
  $('.addon-wrapper').slick({
	infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true
  });
});

// Store Selector
$(".store_selector").on("change", function() {
  var selectedVal = $(this).find(':selected').val();
	
  if (selectedVal == "US") {

  } else if (selectedVal == "CA") {
    window.location.href = "https://ca.ghostkeyboards.com/";
  } else if (selectedVal == "EU") {
    window.location.href = "https://eu.ghostkeyboards.com/";
  } else if (selectedVal == "UK") {
    window.location.href = "https://uk.ghostkeyboards.com/";
  }
});

// Default mega menu hover effect
$('.default-megamenu .site-nav__dropdown-link').hover(function() {
  var new_img = $(this).data('img');
  // set up opacity
  $('.default-megamenu .site-nav__dropdown-link').css("opacity", 0.4);
  $(this).css("opacity", 1);
  // dynamically change collection image
  $(this).parent().siblings('.megamenu__collection-image').css('background-image', 'url('+ new_img + ')');
}, function () {
  var original_img = $(this).parent().siblings('.megamenu__collection-image').data('img');
  $('.default-megamenu .site-nav__dropdown-link').css("opacity", 1);
  $(this).parent().siblings('.megamenu__collection-image').css('background-image', 'url('+ original_img + ')');
})

var document_width = $(document).width();

var ghost_army_img_transition_after = function (el, hightlight_after, normal_after, unit, diff) {
  if (el.find('.highlight').length != 0) {
    el.find('.stories__image').animate({
      width: `${hightlight_after}${unit}`,
      height: `${hightlight_after}${unit}`
    }, 'fast');

    el.find('.stories__image img').animate({
      width: `${hightlight_after-diff}${unit}`,
      height: `${hightlight_after-diff}${unit}`
    }, 'fast');
  } else {
    el.find('.stories__image').animate({
      width: `${normal_after}${unit}`,
      height: `${normal_after}${unit}`
    }, 'fast');

    el.find('.stories__image img').animate({
      width: `${normal_after-diff}${unit}`,
      height: `${normal_after-diff}${unit}`
    }, 'fast');
  }
}

var ghost_army_img_transition_orig = function (el, hightlight_orig, normal_orig, unit, diff) {
  if (el.find('.highlight').length != 0) {
    el.find('.stories__image').animate({
      width: `${hightlight_orig}${unit}`,
      height: `${hightlight_orig}${unit}`
    }, 'fast');

    el.find('.stories__image img').animate({
      width: `${hightlight_orig-diff}${unit}`,
      height: `${hightlight_orig-diff}${unit}`
    }, 'fast');
  } else {
    el.find('.stories__image').animate({
      width: `${normal_orig}${unit}`,
      height: `${normal_orig}${unit}`
    }, 'fast');

    el.find('.stories__image img').animate({
      width: `${normal_orig-diff}${unit}`,
      height: `${normal_orig-diff}${unit}`
    }, 'fast');
  }
}

// Ghost army mega menu hover effect
$('.custom-megamenu .grid__item').hover(function() {
  if (document_width >= 1330) {
    ghost_army_img_transition_after($(this), 180, 130, "px", 10);
  } else {
    ghost_army_img_transition_after($(this), 13, 9, "vw", 1);
  }
}, function() {
  if (document_width >= 1330) {
    ghost_army_img_transition_orig($(this), 160, 100, "px", 10);
  } else {
    ghost_army_img_transition_orig($(this), 12, 8, "vw", 1);
  }
})

// Custom product page description, specifications, features section
const $desc = $('.product-single__description')
const $specs = $('.product-single__specifications')
const $feat = $('.product-single__features')
$('._description').click(function () {
  $(this).addClass("active");
  $('._specifications').removeClass("active");
  $('._features').removeClass("active");
  $('.product-single__specifications, .product-single__features').slideUp(function(){
    $('.product-single__description').delay(500).slideDown();
  });
})
$('._specifications').click(function () {
  $(this).addClass("active");
  $('._description').removeClass("active");
  $('._features').removeClass("active");
  $('.product-single__description, .product-single__features').slideUp(function(){
    $('.product-single__specifications').delay(500).slideDown();
  });
})
$('._features').click(function () {
  $(this).addClass("active");
  $('._description').removeClass("active");
  $('._specifications').removeClass("active");
  $('.product-single__description, .product-single__specifications').slideUp(function(){
    $('.product-single__features').delay(500).slideDown();
  });
})

// Dynamically change position of overlay card image
var window_width = $( window ).width();
if (window_width >= 769) {
  var max_width = 1500;
  var min_width = 769;
  var max_top_pos = 21
  var min_top_pos = 9
  var slope = (max_top_pos-min_top_pos) / (max_width - min_width);
  var starting_pt = max_top_pos - (max_width * slope)
} else {
  var max_width = 768;
  var min_width = 250;
  var max_top_pos = 27
  var min_top_pos = 9
  var slope = (max_top_pos-min_top_pos) / (max_width - min_width);
  var starting_pt = max_top_pos - (max_width * slope)
}
$( window ).on('load resize', function() {
  var window_width = $( window ).width();
  if (min_width <= window_width && window_width <= max_width) {
    
    var top_position = window_width * slope + starting_pt;
    var top_pos_in_percentage = top_position + "%";
    $('.card_image').css('top', top_pos_in_percentage);
  } else if (window_width > max_width) {
    $('.card_image').css('top', '21%');
  }
})

// What's In The Box Custom Section

$('.whats-in-the-box .images_wrapper img').hover(
  function() {
    $('.whats-in-the-box .images_wrapper img').css('filter','grayscale(100%)')
    $('.whats-in-the-box .images_wrapper img').css('opacity', 0.4);
    $(this).css('opacity', 1);
    $(this).css('filter', 'grayscale(0%)');
    var product = $(this).data('num');
    $('.whats-in-the-box .product_info').css('opacity', 1);
    $('.whats-in-the-box .product_title').text($('.whats-in-the-box .product_title').data(String(product)));
    $('.whats-in-the-box .product_desc').text($('.whats-in-the-box .product_desc').data(String(product)));
  }, function() {
    $('.whats-in-the-box .images_wrapper img').css('opacity', 1);
    $('.whats-in-the-box .images_wrapper img').css('filter','grayscale(0%)')
    var product = $(this).data('num');
    $('.whats-in-the-box .product_info').css('opacity', 0);
})

// Move Stock Tracker below the product form
var waitForEl = function(selector, callback) {
  if (jQuery(selector).length) {
    callback();
  } else {
    setTimeout(function() {
      waitForEl(selector, callback);
    }, 100);
  }
};

waitForEl('.stock-top', function() {
  $('.product-single__form').append($('.stock-top'));
});
